import { useEffect } from "react";

export default function SessionExpiryCheck() {
  

  useEffect(() => {
    const checkExpiry = () => {
      const expiryTime = localStorage.getItem("session_expiry");
      if (!expiryTime) return;

      const now = Date.now();

      if (now >= expiryTime) {
        // 🔥 Session expired
        localStorage.clear();
      }
      const expiryTime1 = Date.now() + 3600000;  
      localStorage.setItem("session_expiry", expiryTime1);
    };

    checkExpiry();
  }, []);

  return null;
}
